import { createAction } from 'redux-actions';
import { NotificationType } from './types';
import { makeNotification } from './makeNotification';
import { actionKey } from './constants';
import { NotificationDuration } from '../Notification';
export { type NotificationQueueItem } from './types';

export const addNotificationToQueue = createAction(
  `${actionKey}.ADD`,
  (queueName: string, type: string | NotificationType, params: any) => ({
    notification: makeNotification(type, queueName, params),
    queueName,
  })
);
export const addNotification = (type: string | NotificationType, params: any) =>
  addNotificationToQueue('default', type, params);

export const removeNotificationFromQueue = createAction(
  `${actionKey}.REMOVE`,
  (queueName: string, id: number) => ({ id, queueName })
);
export const removeNotification = (id: number) => removeNotificationFromQueue('default', id);

export const removeQueues = createAction(
  `${actionKey}.REMOVE_QUEUES`,
  (predicate: (queueName: string) => boolean) => ({ predicate })
);

export const addErrorNotification = (message: string, duration = NotificationDuration.XL) =>
  addNotification(NotificationType.Generic, {
    message,
    isError: true,
    cardProps: {
      withShadow: true,
      multiLine: true,
      duration,
    },
  });

export const genericUndoAction = createAction(`${actionKey}.UNDO`, () => ({}));
